export default "__VITE_ASSET__Bv4ecH3q__"